/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => {  });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => {  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


/**
 * SC Article TOC (Table of Contents)
 * - builds menu from headings inside .sc-article-content
 * - injects into .sc-article-menu-navigation
 *
 * Config:
 * 1) Global:
 *    window.SC_ARTICLE_TOC = { headings: "h1,h2,h3", excludeWithin: ".hightlited-h3" };
 * 2) Per container:
 *    <div class="sc-article-container"
 *         data-toc-headings="h1,h2,h3"
 *         data-toc-exclude-within=".hightlited-h3,.another-wrapper">
 */

(() => {
  const DEFAULT_CONFIG = {
    headings: "h1,h2,h3",
    excludeWithin: "",
  };

  function getConfig(container) {
    const globalCfg =
      window.SC_ARTICLE_TOC && typeof window.SC_ARTICLE_TOC === "object"
        ? window.SC_ARTICLE_TOC
        : {};

    const dataHeadings = container.getAttribute("data-toc-headings");
    const dataExcludeWithin = container.getAttribute("data-toc-exclude-within");

    return {
      headings: dataHeadings || globalCfg.headings || DEFAULT_CONFIG.headings,
      excludeWithin:
        dataExcludeWithin || globalCfg.excludeWithin || DEFAULT_CONFIG.excludeWithin,
    };
  }

  function slugify(text) {
    const s = String(text || "")
      .trim()
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, ""); // ö -> o

    return (
      s
        .replace(/[^a-z0-9\u0400-\u04ff\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "") || "section"
    );
  }

  function makeUniqueId(base, used) {
    let id = base;
    let i = 2;
    while (used.has(id)) id = `${base}-${i++}`;
    used.add(id);
    return id;
  }

  function isExcludedHeading(h, cfg) {
    if (!cfg.excludeWithin) return false;
    const selectors = cfg.excludeWithin
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    return selectors.some((sel) => {
      try {
        return !!h.closest(sel);
      } catch (_) {
        return false;
      }
    });
  }

  function buildTOC(container) {
    const nav = container.querySelector(".sc-article-menu-navigation");
    const content = container.querySelector(".sc-article-content");
    if (!nav || !content) return;

    const cfg = getConfig(container);

    const headings = Array.from(content.querySelectorAll(cfg.headings))
      .filter((h) => h && h.textContent && h.textContent.trim().length)
      .filter((h) => !isExcludedHeading(h, cfg));

    nav.innerHTML = "";

    if (!headings.length) {
      container.querySelector(".sc-article-menu")?.classList.add("is-empty");
      return;
    }
    container.querySelector(".sc-article-menu")?.classList.remove("is-empty");

    const used = new Set(
      Array.from(document.querySelectorAll("[id]"))
        .map((el) => el.id)
        .filter(Boolean)
    );

    const ul = document.createElement("ul");
    ul.className = "sc-article-toc";

    headings.forEach((h) => {
      const level = h.tagName.toLowerCase();
      const title = h.textContent.trim();

      let id = (h.id || "").trim();
      if (!id) {
        id = makeUniqueId(slugify(title), used);
        h.id = id;
      } else {
        used.add(id);
      }

      const li = document.createElement("li");
      li.className = `sc-article-toc-item level-${level}`;

      const a = document.createElement("a");
      a.className = "sc-article-toc-link";
      a.href = `#${id}`;
      a.textContent = title;

      li.appendChild(a);
      ul.appendChild(li);
    });

    nav.appendChild(ul);
    updateActiveToc(container);
  }

  function updateActiveToc(container) {
    const nav = container.querySelector(".sc-article-menu-navigation");
    if (!nav) return;

    const links = Array.from(nav.querySelectorAll('a.sc-article-toc-link[href^="#"]'));
    if (!links.length) return;

    const rawHash = window.location.hash || "";
    const hash = rawHash && rawHash !== "#" ? rawHash : "";

    links.forEach((a) => a.classList.remove("is-active"));
    if (!hash) return;
    const active = links.find((a) => (a.getAttribute("href") || "") === hash);
    if (active) active.classList.add("is-active");
  }

  function setupActiveTocHandlers() {
    document.addEventListener(
      "click",
      (e) => {
        const a = e.target?.closest?.("a.sc-article-toc-link");
        if (!a) return;
        queueMicrotask(() => {
          document
            .querySelectorAll(".sc-article-container")
            .forEach(updateActiveToc);
        });
      },
      true
    );

    window.addEventListener("hashchange", () => {
      document
        .querySelectorAll(".sc-article-container")
        .forEach(updateActiveToc);
    });
  }

  function init() {
    setupActiveTocHandlers();
    document.querySelectorAll(".sc-article-container").forEach(buildTOC);

    document.querySelectorAll(".sc-article-container").forEach(updateActiveToc);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target;
    root?.querySelectorAll?.(".sc-article-container").forEach(buildTOC);
  });
})();

(() => {
  class ScStickyManager extends HTMLElement {
    constructor() {
      super();

      this.scTargetSelector = this.getAttribute('data-target-selector') || '[data-sticky="true"]';
      this.scHeaderSelector = this.getAttribute('data-header-selector') || 'header';

      this.scFixedClassName = 'sc-sticky--fixed';
      this.scPlaceholderClassName = 'sc-sticky-placeholder';

      this.scTargetElement = null;
      this.scHeaderElement = null;
      this.scPlaceholderElement = null;

      this.scResizeObserver = null;
      this.scMutationObserver = null;

      this.scAnimationFrameId = 0;
      this.scIsFixedActive = false;

      this.scLatestMarginTopPx = 0;
      this.scLatestMarginBottomPx = 0;
      this.scLatestOuterHeightPx = 0;

      this.scHandleScroll = this.scHandleScroll.bind(this);
      this.scHandleResize = this.scHandleResize.bind(this);
      this.scHandleMutations = this.scHandleMutations.bind(this);
    }

    connectedCallback() {
      this.style.display = 'none';

      window.addEventListener('scroll', this.scHandleScroll, { passive: true });
      window.addEventListener('resize', this.scHandleResize, { passive: true });

      this.scMutationObserver = new MutationObserver(this.scHandleMutations);
      this.scMutationObserver.observe(document.documentElement, { childList: true, subtree: true });

      this.scResolveHeaderElement();
      this.scResolveAndAttachToFirstTarget();
      this.scRequestUpdate();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scHandleScroll);
      window.removeEventListener('resize', this.scHandleResize);

      if (this.scMutationObserver) this.scMutationObserver.disconnect();
      this.scMutationObserver = null;

      this.scDetachFromCurrentTarget();

      if (this.scAnimationFrameId) cancelAnimationFrame(this.scAnimationFrameId);
      this.scAnimationFrameId = 0;
    }

    scHandleScroll() {
      this.scRequestUpdate();
    }

    scHandleResize() {
      this.scResolveHeaderElement();
      this.scMeasureCurrentTargetGeometry();
      this.scRequestUpdate();
    }

    scHandleMutations() {
      this.scResolveHeaderElement();

      if (this.scTargetElement && !document.documentElement.contains(this.scTargetElement)) {
        this.scDetachFromCurrentTarget();
      }

      this.scResolveAndAttachToFirstTarget();
      this.scRequestUpdate();
    }

    scRequestUpdate() {
      if (this.scAnimationFrameId) return;
      this.scAnimationFrameId = requestAnimationFrame(() => {
        this.scAnimationFrameId = 0;
        this.scUpdateStickyStateAndPosition();
      });
    }

    scResolveHeaderElement() {
      const resolvedHeader = document.querySelector(this.scHeaderSelector);
      this.scHeaderElement = resolvedHeader || null;
    }

    scResolveAndAttachToFirstTarget() {
      const firstStickyTarget = document.querySelector(this.scTargetSelector);

      if (!firstStickyTarget) {
        this.scDetachFromCurrentTarget();
        return;
      }

      if (firstStickyTarget === this.scTargetElement) return;

      this.scDetachFromCurrentTarget();
      this.scAttachToTarget(firstStickyTarget);
    }

    scAttachToTarget(targetElement) {
      this.scTargetElement = targetElement;

      const placeholderElement = document.createElement('div');
      placeholderElement.className = this.scPlaceholderClassName;

      targetElement.parentNode.insertBefore(placeholderElement, targetElement);
      this.scPlaceholderElement = placeholderElement;

      this.scResizeObserver = new ResizeObserver(() => {
        this.scMeasureCurrentTargetGeometry();
        this.scRequestUpdate();
      });

      this.scResizeObserver.observe(this.scTargetElement);

      if (this.scHeaderElement) {
        this.scResizeObserver.observe(this.scHeaderElement);
      }

      this.scMeasureCurrentTargetGeometry();
    }

    scDetachFromCurrentTarget() {
      if (this.scResizeObserver) this.scResizeObserver.disconnect();
      this.scResizeObserver = null;

      if (this.scTargetElement) {
        this.scTargetElement.classList.remove(this.scFixedClassName);
        this.scTargetElement.style.removeProperty('--sc-sticky-top');
        this.scTargetElement.style.removeProperty('--sc-sticky-left');
        this.scTargetElement.style.removeProperty('--sc-sticky-width');
      }

      if (this.scPlaceholderElement && this.scPlaceholderElement.parentNode) {
        this.scPlaceholderElement.parentNode.removeChild(this.scPlaceholderElement);
      }

      this.scTargetElement = null;
      this.scPlaceholderElement = null;

      this.scIsFixedActive = false;
      this.scLatestMarginTopPx = 0;
      this.scLatestMarginBottomPx = 0;
      this.scLatestOuterHeightPx = 0;
    }

    scMeasureCurrentTargetGeometry() {
      if (!this.scTargetElement) return;

      const computedStyle = getComputedStyle(this.scTargetElement);
      const marginTopPx = Number.parseFloat(computedStyle.marginTop) || 0;
      const marginBottomPx = Number.parseFloat(computedStyle.marginBottom) || 0;

      const targetRect = this.scTargetElement.getBoundingClientRect();
      const outerHeightPx = Math.max(0, targetRect.height + marginTopPx + marginBottomPx);

      this.scLatestMarginTopPx = marginTopPx;
      this.scLatestMarginBottomPx = marginBottomPx;
      this.scLatestOuterHeightPx = outerHeightPx;

      if (this.scIsFixedActive && this.scPlaceholderElement) {
        this.scPlaceholderElement.style.height = `${outerHeightPx}px`;
      }
    }

    scConvertCssLengthToPx(cssLength) {
      const normalizedValue = String(cssLength || '').trim();
      if (!normalizedValue) return 0;
      if (normalizedValue.endsWith('px')) return Number.parseFloat(normalizedValue) || 0;

      const probeElement = document.createElement('div');
      probeElement.style.position = 'absolute';
      probeElement.style.visibility = 'hidden';
      probeElement.style.width = normalizedValue;

      document.body.appendChild(probeElement);
      const resolvedPx = probeElement.getBoundingClientRect().width || 0;
      probeElement.remove();

      return resolvedPx;
    }

    scResolveHeaderBottomOffsetPx() {
      if (this.scHeaderElement) {
        const headerRect = this.scHeaderElement.getBoundingClientRect();
        if (headerRect.height > 0) return Math.max(0, headerRect.bottom);
      }

      const rootComputedStyle = getComputedStyle(document.documentElement);
      const headerHeightVariable = rootComputedStyle.getPropertyValue('--header-height');
      return Math.max(0, this.scConvertCssLengthToPx(headerHeightVariable));
    }

    scApplyFixedState() {
      if (!this.scTargetElement || !this.scPlaceholderElement) return;

      this.scIsFixedActive = true;

      this.scPlaceholderElement.style.height = `${this.scLatestOuterHeightPx}px`;
      this.scTargetElement.classList.add(this.scFixedClassName);
    }

    scRemoveFixedState() {
      if (!this.scTargetElement || !this.scPlaceholderElement) return;

      this.scIsFixedActive = false;

      this.scPlaceholderElement.style.height = `0px`;
      this.scTargetElement.classList.remove(this.scFixedClassName);

      this.scTargetElement.style.removeProperty('--sc-sticky-top');
      this.scTargetElement.style.removeProperty('--sc-sticky-left');
      this.scTargetElement.style.removeProperty('--sc-sticky-width');
    }

    scUpdateFixedPositionVariables() {
      if (!this.scTargetElement || !this.scPlaceholderElement) return;

      const headerBottomOffsetPx = this.scResolveHeaderBottomOffsetPx();
      const fixedTopOffsetPx = Math.max(0, headerBottomOffsetPx - this.scLatestMarginTopPx);

      const placeholderRect = this.scPlaceholderElement.getBoundingClientRect();

      this.scTargetElement.style.setProperty('--sc-sticky-top', `${fixedTopOffsetPx}px`);
      this.scTargetElement.style.setProperty('--sc-sticky-left', `${placeholderRect.left}px`);
      this.scTargetElement.style.setProperty('--sc-sticky-width', `${placeholderRect.width}px`);
    }

    scUpdateStickyStateAndPosition() {
      if (!this.scTargetElement || !this.scPlaceholderElement) return;

      const headerBottomOffsetPx = this.scResolveHeaderBottomOffsetPx();
      const placeholderRect = this.scPlaceholderElement.getBoundingClientRect();

      const shouldBeFixedNow = placeholderRect.top <= headerBottomOffsetPx;

      if (shouldBeFixedNow && !this.scIsFixedActive) {
        this.scMeasureCurrentTargetGeometry();
        this.scApplyFixedState();
      }

      if (!shouldBeFixedNow && this.scIsFixedActive) {
        this.scRemoveFixedState();
        return;
      }

      if (this.scIsFixedActive) {
        this.scUpdateFixedPositionVariables();
      }
    }
  }

  if (!customElements.get('sc-sticky-manager')) {
    customElements.define('sc-sticky-manager', ScStickyManager);
  }

  const scEnsureSingleManagerInstance = () => {
    if (document.querySelector('sc-sticky-manager')) return;
    const managerElement = document.createElement('sc-sticky-manager');
    document.body.appendChild(managerElement);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scEnsureSingleManagerInstance, { once: true });
  } else {
    scEnsureSingleManagerInstance();
  }
})();